module.exports = __webpack_public_path__ + "static/media/website-05.8618602b.png";